<!-- 乗車日 -->
<template>
  <div class="row">
    <div class="th cell">乗車日</div>
    <div class="cell">{{ displayMfittDetailDate(boardingDate) }}</div>
  </div>
</template>

<script>
export default {
  name: "ViBoardingDate",
  props: {
    boardingDate: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
</style>
